import axios from "axios";
import Config from "../utils/Config";

class TemplateService {
    config = {
        headers: {
          Authorization: "",
          GroupId: "",
          CompanyId: "",
        },
      };
    
      setAccessToken(accessToken, groupId, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.GroupId = groupId;
        this.config.headers.CompanyId = companyId;
      }

    // get template by groupId companyId
    async getTemplateByGroupIdCompanyId (accessToken, groupId, companyId){
        this.setAccessToken(accessToken, groupId, companyId);
        const sanitizedGroupId = groupId || '';
        const sanitizedCompanyId = companyId || '';
            const data = await axios.get(
                Config.BACKEND_URL + `/api/template/company?groupId=${sanitizedGroupId}&companyId=${sanitizedCompanyId}`, ///api/template/company
                this.config
            )
            //console.log(JSON.stringify(data.data));
            return data.data;
        }

    // get template by id
    async getTemplateById (accessToken, groupId, companyId, templateId){
    this.setAccessToken(accessToken, groupId, companyId);
        const data = await axios.get(
            Config.BACKEND_URL + `/api/template/${templateId}`, ///api/template/{templateId}
            this.config
        )
        return data.data;
    }

    //template upload
    async templateUpload (accessToken, groupId, companyId, formData,onUploadProgress){
        this.setAccessToken(accessToken, groupId, companyId);
    
        const data = await axios.post(
            Config.BACKEND_URL + "/api/template/upload", //api/template/upload
            formData,
            { headers:{"Authorization":accessToken, "GroupId":groupId, "CompanyId":companyId},
            onUploadProgress}
          );
          return data.data;
      }

      //update template
      async updateTemplate (accessToken, groupId, companyId, templateId, formData){
        this.setAccessToken(accessToken, groupId, companyId);
        
        const data = await axios.patch(
            Config.BACKEND_URL + `/api/template/${templateId}`, //api/template/{templateId}
            formData,
            this.config
          )
          return data.data;
      }

      //download template by id
      async downloadTemplateById (accessToken, groupId, companyId, templateId){
        this.setAccessToken(accessToken, groupId, companyId);
        const response = await axios.get(
            Config.BACKEND_URL + `/api/template/download/${templateId}`, //api/template/download/{templateId}
            {
              ...this.config,
              responseType: 'blob' // Important: Set response type to blob for binary data
            }
          )
          return response;
      }
};

export default new TemplateService();